// Vendors
import React from 'react'
import { useParams } from 'react-router'

// Components
import { CompanyLaboratoryFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageCompanyLaboratoryShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <LayoutLoggedPageList title={title}>
      <CompanyLaboratoryFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
